import { SpectrumColor } from '../types';

export const Green: SpectrumColor = {
  0: '#F5FEF9',
  5: '#E3FCEF',
  10: '#D2F9E5',
  15: '#BDF4D8',
  20: '#A8EFCB',
  25: '#95E4BC',
  30: '#81D9AD',
  35: '#56CD91',
  40: '#2AC075',
  50: '#28B06C',
  60: '#1DA15F',
  70: '#17874F',
  80: '#137343',
  90: '#0F5B35',
  100: '#0C4629',
  110: '#09331E',
  default: 80,
};
